import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()

export class OrdersReportServices {

    backendUrl: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;

    api = "/ordersreport/"

    constructor(private http: AuthHttp) {
        // this.backendUrl = environment.url;
        this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
        this.secret = environment.secret;
    }


    getallBranchesDataConfiguration(id:any,br_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-branch-data-restaurant/${id}/${br_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallOrdersReportByDateConfiguration(id:any,dt_time:any,br_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-orders-report-time/${id}/${dt_time}/${br_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallSearchOrderReport(data) {
        return this.http.post(`${this.backendUrl}${this.api}search-order-report/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/ordersreport.service.ts